import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AppComponent } from './app/app.component'
import localeEnIN from '@angular/common/locales/en-IN'
import { registerLocaleData } from '@angular/common'

registerLocaleData(localeEnIN)

bootstrapApplication(AppComponent, appConfig)
  // .then(() => {
  //   document.body.classList.remove('loading')
  // })
   
  .catch(err => console.error(err))
// Remove loading immediately after first paint
requestAnimationFrame(() => {
  document.body.classList.remove('loading')
})
// Register Firebase service worker AFTER the app stabilizes
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(reg => console.log('Service Worker registered', reg))
      .catch(err => console.error('Service Worker registration failed', err))
  })
}
